exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-list-item[data-v-211f81e0]{color:#c6c6c6;font-size:.18rem}.file-list-item>div[data-v-211f81e0]{color:#1a59f6}.file-list-item>svg[data-v-211f81e0]{cursor:pointer;margin-left:.28rem}", ""]);

// exports
